<blaze-dialog [showCloseButton]="false" [showFooter]="false" contentClass="pt-16">
  <div icon class="title-icon">
    <mat-icon svgIcon="icon_blaze_24" />
  </div>

  <div title>Please Provide Test Values</div>

  <div actions>
    <button blazeIconButton (click)="closeDialog()">
      <mat-icon svgIcon="icon_close_16" />
    </button>
  </div>

  <div content>
    <form (ngSubmit)="save()">
      <div class="parameters-list">
        @for (param of parametersDef; track param; let i = $index) {
          <div class="param-name">{{ param.name }}</div>
          <div class="param-value">
            <blaze-typed-value-input-field
              [dataType]="param.dataType"
              [fieldCtrl]="formCtrl.controls[i]"
              fieldName="testValue[{{ i }}]"
            />
          </div>
        }
      </div>

      <button class="w-full" type="submit" blazeButton [disabled]="formCtrl.invalid"> TEST </button>
    </form>
  </div>
</blaze-dialog>
